import {
    AMOUNT_STEP,
    NAME_STEP,
    GREETING_STEP,
    PAYMENT_SUMMARY_STEP,
} from './standard-payment-wizard/payment-wizard-path-constants';
import {
    GIFT_CARD_AMOUNT_STEP,
    GIFT_CARD_NAME_STEP,
    GIFT_CARD_PREVIEW_STEP,
    GIFT_CARD_SUMMARY_STEP,
} from './gift-card-payment-wizard/gift-card-wizard-path-constants';

export const GIFT_CARD_WIZARD_TYPE = 'GIFT_CARD_WIZARD';
export const PAYMENT_WIZARD_TYPE = 'PAYMENT_WIZARD';

export const getPaymentWizardFieldImage = (field, wizardType) => {
    if (wizardType === GIFT_CARD_WIZARD_TYPE) {
        switch (field) {
            case GIFT_CARD_AMOUNT_STEP:
                return '/public/images/fund-as-gift/rosa-gris-med-penge.svg';
            case GIFT_CARD_NAME_STEP:
                return '/public/images/fund-as-gift/hand-gave.svg';
            case GIFT_CARD_PREVIEW_STEP:
                return '/public/images/fund-as-gift/konfettifløyte.svg';
            case GIFT_CARD_SUMMARY_STEP:
                return '/public/images/fund-as-gift/gave-1.svg';
            default:
                return '/public/images/fund-as-gift/gave-1.svg';
        }
    }

    switch (field) {
        case AMOUNT_STEP:
            return '/public/images/fund-as-gift/rosa-gris-med-penge.svg';
        case NAME_STEP:
            return '/public/images/fund-as-gift/hand-sign.svg';
        case GREETING_STEP:
            return '/public/images/fund-as-gift/hand-gave.svg';
        case PAYMENT_SUMMARY_STEP:
            return '/public/images/fund-as-gift/gave-1.svg';
        default:
            return '/public/images/fund-as-gift/gave-1.svg';
    }
};

export const getProgressInPercentage = (field, wizardFields) => {
    const positionInWizard = wizardFields.indexOf(field);
    return (positionInWizard / wizardFields.length) * 100;
};

export const isOnFirstField = (currentField, wizardFields) => wizardFields.indexOf(currentField) === 0;

export const goToNextField = ({ navigate, currentField, wizardFields, customGoToField = '' }) => {
    if (!currentField) {
        return navigate(`../${wizardFields[0]}`, { replace: true });
    }

    if (customGoToField) {
        return navigate(`../${customGoToField}`);
    }

    const indexOfCurrentField = wizardFields.indexOf(currentField);
    if (indexOfCurrentField < wizardFields.length - 1) {
        return navigate(`../${wizardFields[indexOfCurrentField + 1]}`);
    }

    return navigate(`../${wizardFields[wizardFields.length - 1]}`);
};

export const goToPreviousField = ({ currentField, navigate, wizardFields }) => {
    const indexOfCurrentField = wizardFields.indexOf(currentField);
    if (indexOfCurrentField > 0 && indexOfCurrentField < wizardFields.length + 1) {
        return navigate(`../${wizardFields[indexOfCurrentField - 1]}`);
    }
};
